export const GET_CURRENT_CONSENT_APPLICATION_SUCCESS = "GET_CURRENT_CONSENT_APPLICATION_SUCCESS";
export const GET_CURRENT_CONSENT_APPLICATION = "GET_CURRENT_CONSENT_APPLICATION"

export const GET_CONSENT_OTP_SUCCESS= "GET_CONSENT_OTP_SUCCESS";
export const GET_CONSENT_OTP = "GET_CONSENT_OTP";

export const GET_VERIFY_CONSENT_OTP_SUCCESS= "GET_VERIFY_CONSENT_OTP_SUCCESS";
export const GET_VERIFY_CONSENT_OTP = "GET_VERIFY_CONSENT_OTP";

export const GET_RESEND_CONSENT_OTP_SUCCESS= "GET_RESEND_CONSENT_OTP_SUCCESS";
export const GET_RESEND_CONSENT_OTP = "GET_RESEND_CONSENT_OTP";

export const CHECK_CONSENT_COMPLETED_SUCCESS= "CHECK_CONSENT_COMPLETED_SUCCESS";
export const CHECK_CONSENT_COMPLETED = "CHECK_CONSENT_COMPLETED";


// GET__APPLICATION_LOGIN_DETAILS_SUCCESS, GET__APPLICATION_LOGIN_DETAILS
export const GET__APPLICATION_LOGIN_DETAILS_SUCCESS= "GET__APPLICATION_LOGIN_DETAILS_SUCCESS";
export const GET__APPLICATION_LOGIN_DETAILS = "GET__APPLICATION_LOGIN_DETAILS";

